import { lazy } from 'react';

const StorefrontHomeLayoutUsedRoutes = [
  {
    path: 'storefront/home-layout-used/section/add',
    component: lazy(() => import('views/storefront-home-layout-used/section-add')),
  },
  {
    path: 'storefront/home-layout-used/section/new/:type',
    component: lazy(() => import('views/storefront-home-layout-used/section-form-page')),
  },
  {
    path: 'storefront/home-layout-used/section/edit/:uuid',
    component: lazy(() => import('views/storefront-home-layout-used/section-form-page')),
  },
  {
    path: 'storefront/home-layout-used',
    component: lazy(() => import('views/storefront-home-layout-used')),
  },
];

export default StorefrontHomeLayoutUsedRoutes;
